<template>
    <div class="contents">
        <div class="title">
            전환인증 메일정보
            <div class="clear"></div>
        </div>
        <div class="c_table_wrap">
<!--            <table v-if="storeList.length > 0">-->
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr v-for="store in storeList" :key="store.s_idx">
                    <td class="c_t_title">{{ store.s_name }}</td>
                    <td colspan="3">
                        <div class="mpc_store" style="">
                            <el-input v-model="store.sm_email"></el-input>
                        </div>
                        <el-button type="primary" class="search_btn" @click="updateMember(store)">수정</el-button>

                    </td>
                </tr>
            </table>
<!--            <div v-else>-->
<!--                등록된 스토어가 없습니다.-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";

export default {
    name: "PointStoreComponent",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        memberKey: {
            default: () => {
            }
        },
    },
    data() {
        return {
            storeList: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.getStoreList();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getStoreList() {
            let params = {
                ip: 0,
                no: this.memberKey,
            }
            try {
                this.$api.$store.getMemberStore(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type === 1) {
                        this.storeList = res.List
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },

        updateMember(store) {
            if (util.isEmpty(store.sm_email)) {
                this.errorAlert('필수값을 입력해 주세요')
                return
            }
            let params = {
                sm_email: store.sm_email,
                sm_idx: store.sm_idx
            }
            try {
                this.$api.$store.updateMemberStore(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type === 1) {
                        this.createAlert({
                            title: '',
                            content: '수정 되었습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.getStoreList()
                            }
                        })
                    } else {
                        this.errorAlert('수정에 실패했습니다.')
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
    },
    watch: {},
}
</script>

<style lang="scss">
.mpc_store {
    display: inline-block;
    width: calc(100% - 120px);
    margin-right: 10px;
}
</style>
